import { ClientFetch } from '../../fetch/ClientFetch';
import { HTTP_METHODS } from 'utils';

const NAMESPACE = 'try_catch_error';

/**
 * Logs an error using the PSI service interface.
 * @param error - The Error object to be logged.
 */
export async function errorLogging(error: Error): Promise<void> {
  await new ClientFetch().makePsiRequest(
    'base.status.log',
    { ns: NAMESPACE, msg: error.toString() },
    { method: HTTP_METHODS.POST },
  );
}
